<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.FAMILY_POWER
    );
  }
}
</script>

<template>
  <AccordionComponent type="white" @opened="getData" v-model="isOpen">
    <template #title>
      {{ t("calculators.destiny-matrix.accordions.family-power.title") }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-2">
        <div class="whitespace-pre-line">
          {{ t("calculators.destiny-matrix.accordions.family-power.desc") }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.family-power.value-title",
              { value: matrix.middle_points.right_center }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description }}
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
